import React, { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { AICreationWorkspace } from "@core/components/ai/AICreationWorkspace";
import { ProductSidebar } from "@core/components/layout/products/ProductSidebar";
import { ProductHeader } from "@core/components/layout/products/ProductHeader";

/**
 * Workspace de création pour les sondages de formulaires
 * Utilise AICreationWorkspace avec ProductSidebar pour avoir le menu de gauche
 */
export default function FormPollCreationWorkspace() {
  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    // S'assurer que le type "form" est dans les search params
    if (searchParams.get("type") !== "form") {
      searchParams.set("type", "form");
      setSearchParams(searchParams);
    }
  }, [searchParams, setSearchParams]);

  return (
    <div className="flex flex-col h-screen bg-[#0a0a0a] overflow-hidden">
      {/* Header en haut - position fixe pour qu'il soit toujours visible */}
      <div className="fixed top-0 left-0 right-0 z-50 w-full">
        <ProductHeader
          productType="form"
          showAuth={true}
          showAuthButtons={true}
        />
      </div>

      {/* Contenu principal avec sidebar - prend le reste de la hauteur */}
      <div className="flex flex-1 overflow-hidden">
        {/* Sidebar */}
        <ProductSidebar productType="form" />

        {/* Contenu principal - AICreationWorkspace sans sa propre sidebar */}
        <AICreationWorkspace
          pollTypeFromUrl="form"
          hideSidebar={true}
          externalHeaderHeight={64}
        />
      </div>
    </div>
  );
}
